exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n  You can use BEM style even though you are scoped. Helps to reason about\n  your styles.\n*/\n.ev-appnav__logo[data-v-da5b5576] {\n  width: 40px;\n  filter: brightness(0%);\n}\n.ev-appnav__search[data-v-da5b5576] {\n  margin-right: 10px;\n}\n.ev-appnav__logout[data-v-da5b5576] {\n  margin-top: 1px;\n}\n", ""]);

// exports
